import { IRoleExtraIsBuyerLang } from '../../../types/lang'
import { ERoleExtraIsBuyer } from '../../../types'

export const roleExtraIsBuyerLang: IRoleExtraIsBuyerLang = {
	role_extra_is_buyer: {
		[ERoleExtraIsBuyer.Buyer]: 'Buyer',
		[ERoleExtraIsBuyer.NotBuyer]: 'Not Buyer',
	}
}